export default "__VITE_ASSET__PU_ty8fO__"